export default {
  state: {
    alumno: null,
    centro: null,
    dispositivos: [],
    form: {},
    hookEndPoint: "/hooks/recogida-equipamiento/",
    modelosRenove: [],
    posiblesAlumnos: [],
    validPassword: false,
  },
  setSchool(school) {
    this.state.centro = school;
  },
};
